import { z } from 'zod';

export const TrafficSource = z.enum([
  'CONTEXTUAL',
  'UNBOUNCE',
  'SURVEY',
  'ORGANIC',
]);

// eslint-disable-next-line no-redeclare
export type TrafficSource = z.infer<typeof TrafficSource>;
